import BaseRequest from '@common/services/_baseRequest';


export default {

  list: (vars = {}, id_lezione = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      vars,
      {},
      null,
      'get',
      `affidamento/lezione/${id_lezione}/programma`,
      cb,
      ecb || null,
      null
    );
  },

  detail: (params = {}, id_lezione = null, id = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      params,
      {},
      null,
      'get',
      `affidamento/lezione/${id_lezione}/programma/${id}`,
      cb,
      ecb || null,
      null
    );
  },

  create: (data = {}, id_lezione = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      data,
      null,
      'post',
      `affidamento/lezione/${id_lezione}/programma`,
      cb,
      ecb || null,
      null
    );
  },

  update: (params = {}, id_lezione = null, id = null, cb = null, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      params,
      null,
      'put',
      `affidamento/lezione/${id_lezione}/programma/${id}`,
      cb,
      ecb || null,
      null
    );
  },

  delete: (id_lezione, id, cb, ecb = null) => {
    var req = new BaseRequest();
    return req.makeRequest(
      {},
      {},
      null,
      'delete',
      `affidamento/lezione/${id_lezione}/programma/${id}`,
      cb,
      ecb || null,
      null
    );
  },

}
